import React from 'react';

import {useStore} from 'effector-react';
import {generatePath} from 'react-router-dom';

import {Link} from 'components/ui-kit/Link';
import {ROUTE} from 'core/routes';
import {permissions$} from 'models/auth';
import {UserPermission} from 'types';
import {toHex} from 'utils/string';

export function AuditReference({
    field,
    value,
    notificationId,
}: {
    field: string;
    value: unknown;
    notificationId?: string;
}) {
    const permissions = useStore(permissions$);
    const text = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
    let to: string | undefined;
    if (text && text !== '—' && text !== '-') {
        if (field === 'documentId' && permissions.includes(UserPermission.DOCUMENT_DETAIL_VIEW))
            to = generatePath(ROUTE.DOCUMENTS_DETAIL, {id: text});
        if (
            [
                'markingCode',
                'oldMarkingCode',
                'newMarkingCode',
                'replacesMarkingCodeId',
                'replacedByMarkingCodeId',
            ].includes(field) &&
            [
                UserPermission.PRODUCT_CARD_VIEW,
                UserPermission.PRODUCT_DETAIL_VIEW,
                UserPermission.RECEIPT_CARD_VIEW,
            ].some((p) => permissions.includes(p))
        )
            to = generatePath(ROUTE.PRODUCTS_DETAIL, {id: toHex('null§' + text)});
        if (
            field === 'productId' &&
            permissions.includes(UserPermission.GTIN_DETAIL_VIEW) &&
            [UserPermission.GTIN_GRID_VIEW, UserPermission.ALL_GTIN_GRID_VIEW].some((p) =>
                permissions.includes(p),
            )
        )
            to = ROUTE.REGISTRIES_GTIN_FAVORITES + '?productId=' + encodeURIComponent(text);
        if (
            ['notificationId', 'declarationNumber'].includes(field) &&
            notificationId &&
            permissions.includes(UserPermission.CUSTOMS_DECLARATION_LIST)
        )
            to = generatePath(ROUTE.DECLARATION_DETAILS, {id: notificationId});
    }
    return to ? (
        <Link to={to} onClick={(event) => event.stopPropagation()}>
            {text}
        </Link>
    ) : (
        <>{text || '—'}</>
    );
}
